import * as React from 'react';

import {
  ResolutionStatus,
  type SuggestionAction,
} from 'bundles/ai-coach-platform/components/patterns/suggestions/types';

type CoachSuggestionState = {
  id: string;
  status: ResolutionStatus;
  isExpanded: boolean;
  onAction: (action: SuggestionAction) => void;
  onToggle: (expanded: boolean) => void;
};

export const CoachSuggestionContext = React.createContext<CoachSuggestionState>({
  id: '',
  status: ResolutionStatus.UNRESOLVED,
  isExpanded: false,
  onAction: () => undefined,
  onToggle: () => undefined,
});

export const useCoachSuggestionContext = () => React.useContext(CoachSuggestionContext);
